import { CRESO_OFFICE_DETAILS } from "creso-core/constants";
import { COBClientDetail } from "creso-core/types";
import { Send, Copy } from "lucide-react";
import { useMemo, useState } from "react";
import {
  PopoverTrigger,
  Popover,
  Button,
  PopoverContent,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "web-design-system";
import { useCob } from "../providers/cob-provider";

export function ConfirmCobTransit({
  client,
  folioId,
  trigger,
}: {
  client: COBClientDetail;
  folioId?: number[];
  trigger?: React.ReactNode;
}) {
  const { markCobFormInTransit } = useCob();

  const [confirmOpen, setConfirmOpen] = useState(false);

  const folios = useMemo(() => {
    if (folioId) {
      return client.folio_details.filter((fd) => folioId.includes(fd.folio));
    }
    return client.folio_details.filter((f) => f.status === "DOWNLOADED");
  }, [client.folio_details, folioId]);

  const canDownload = folios.some((f) => f?.status === "DOWNLOADED");

  function handleConfirm() {
    markCobFormInTransit(
      client,
      folios.map((f) => f.folio)
    );
    setConfirmOpen(false);
  }

  function copyAddress() {
    navigator.clipboard.writeText(
      `${CRESO_OFFICE_DETAILS.name}\n${CRESO_OFFICE_DETAILS.address}\nPhone: ${CRESO_OFFICE_DETAILS.phone}`
    );
  }

  if (!canDownload) return null;

  return (
    <Popover open={confirmOpen} onOpenChange={setConfirmOpen}>
      {trigger ? (
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      ) : (
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button variant="ghost" size="icon">
                <Send />
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent>Mark as couriered</TooltipContent>
        </Tooltip>
      )}
      <PopoverContent
        align="end"
        side="top"
        className="w-120 flex flex-col gap-3 bg-card"
      >
        <p className="text-sm text-muted-foreground">
          Send the signed form to Creso at the office address below.
        </p>
        <div className="relative rounded-lg bg-background px-4 py-3 flex flex-col gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-2 right-2"
            onClick={copyAddress}
          >
            <Copy />
          </Button>
          <span className="text-sm font-semibold pr-8">
            {CRESO_OFFICE_DETAILS.name}
          </span>
          <span className="text-sm text-muted-foreground">
            {CRESO_OFFICE_DETAILS.address}
          </span>
          <span className="text-sm text-muted-foreground mt-1">
            Phone: {CRESO_OFFICE_DETAILS.phone}
          </span>
        </div>
        <div className="flex justify-end">
          <Button size="sm" onClick={handleConfirm}>
            Mark as Couriered
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
